// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Primitive_string from "@rescript/runtime/lib/es6/Primitive_string.js";
import * as JsxRuntime from "react/jsx-runtime";

let pattern = /^0x[0-9a-f]{16}$/;

function toString(str) {
  return str._0;
}

function fromString(str) {
  if (pattern.test(str)) {
    return {
      TAG: "Address",
      _0: str
    };
  }
}

let stringCodec = {
  toString: toString,
  fromString: fromString
};

let jsonCodec = LumiJzon.stringCodec(stringCodec);

function Zigbee$Address(props) {
  return JsxRuntime.jsx("span", {
    children: props.address._0,
    className: "is-family-monospace"
  });
}

function cmp(a, b) {
  return Primitive_string.compare(a._0, b._0);
}

let Cmp = Belt_Id.MakeComparable({
  cmp: cmp
});

let Address = {
  pattern: pattern,
  toString: toString,
  fromString: fromString,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec,
  make: Zigbee$Address,
  Cmp: Cmp
};

export {
  Address,
}
/* jsonCodec Not a pure module */
